import { render, staticRenderFns } from "./MapdTables.vue?vue&type=template&id=520fbf61&lang=pug"
import script from "./MapdTables.vue?vue&type=script&lang=js"
export * from "./MapdTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlanCard: require('/home/docker/code/frontend/components/PlanCard.vue').default})
